import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { IB2CUserRepository } from "features/b2cUserManagement/domain/repositories/IB2CUserRepository";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { B2CUserActionRequestModel } from "./model/B2CUserActionRequestModel";
import { B2CUserRequestModel } from "./model/B2CUserRequestModel";
import { B2CUserResponseModel } from "./model/B2CUserResponseModel";
import { BaseDetailUserResponseModel } from "app/based/baseApiModel/baseUserModel/detail/BaseDetailUserResponseModel";

@injectable()
export class B2CUserManagementImpl implements IB2CUserRepository {
  async getList(
    params: B2CUserRequestModel,
    path: string,
  ): Promise<ListBaseApiResponseModel<B2CUserResponseModel>> {
    if (isEmpty(path)) {
      return;
    } else {
      return await client?.get(path, params);
    }
  }

  async getDetail(
    params: B2CUserRequestModel,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseModel & BaseDetailUserResponseModel>> {
    if (isEmpty(path)) {
      return;
    } else {
      return await client?.get(path, params);
    }
  }

  async createUser(
    body: B2CUserActionRequestModel,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseModel>> {
    if (isEmpty(path)) {
      return;
    } else {
      return await client?.post(path, body);
    }
  }

  async updateUser(
    body: B2CUserActionRequestModel,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseModel>> {
    if (isEmpty(path)) {
      return;
    } else {
      return await client?.put(path, body);
    }
  }

  async deleteUser(
    params: B2CUserActionRequestModel,
    path: string,
  ): Promise<BaseApiResponseModel<B2CUserResponseModel>> {
    if (isEmpty(path)) {
      return;
    } else {
      return await client?.delete(path, params);
    }
  }
}
